import { Asset2ReviewStatus } from '../../../../../../apis/graphql';
import type { ValueOf } from '../../../../types/util';
import type { StatusLabel } from '../types';
import { StageLabels } from '../types';
import { LabelType } from './LabelType';

export const validReviewStatusListAsset2: string[] = [
  Asset2ReviewStatus.Accepted,
  Asset2ReviewStatus.Pending,
  Asset2ReviewStatus.SpDeferred,
  Asset2ReviewStatus.Declined,
];

export function getReviewLabelAsset2(status?: string | null): StatusLabel {
  if (!status || !validReviewStatusListAsset2.includes(status)) return null;

  let type: ValueOf<typeof LabelType> = LabelType.IN_PROGRESS;

  if (status === Asset2ReviewStatus.Accepted) type = LabelType.SUCCESS;
  if (status === Asset2ReviewStatus.Declined) type = LabelType.ERROR;

  return {
    label: status,
    type,
    stage: StageLabels.Review,
  };
}
